<template>
  <div class="form__container">
    <header class="form__container__header">
    <h2 v-html="title" class="form__container__title" />
    <v-spacer v-if="kind === 'employee'" />
    <v-checkbox
      v-if="kind === 'employee'"
      v-model="shouldSendWelcomeEmail"
      :label="$t(`${namespace}.checkboxLabel`)"
      hide-details
    />
    </header>

    <div class="form__container__content pt-3">
      <label class="upload">
        <p v-html="$t(`${namespace}.text`)" class="form__container__desc upload__text" />
        <v-btn
          color="primary"
          :loading="isLoading"
          :disabled="isLoading"
          large
          depressed
          rounded
        >
          <v-icon class="mr-2">cloud_upload</v-icon>
          <span class="hidden-xs--inline">{{ buttonLabel }}</span>
          <span class="visible-xs--inline">{{ $t(`${namespace}.import`) }}</span>
        </v-btn>

        <XLSXInput
          v-if="!isLoading"
          class="upload__input"
          :maxLines="maxLines"
          :worksheetTarget="worksheetTarget"
          :supportedFileTypes="supportedFileTypes"
          hide
          @change="handleChange"
          @success="handleSuccess"
          @error="handleError"
        />
      </label>
    </div>
  </div>
</template>

<script>
import { formatNumber } from 'utils/functions'
import XLSXInputMixin from 'mixins/XLSXInput'
import XLSXInput from 'components/bulkImport/stepOne/XLSXInput'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'UploadBox',
  props: {
    kind: {
      type: String
    },
    maxLines: {
      type: Number,
      default: 1000
    },
    maxLinesTitle: {
      type: Boolean,
      default: false
    },
    worksheetTarget: {
      type: [String, Array]
    },
    supportedFileTypes: {
      type: Array
    }
  },
  mixins: [XLSXInputMixin],
  components: {
    XLSXInput
  },
  computed: {
    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },

    type () {
      if (this.kind === 'costCenter') {
        return this.$t('Common.costCenters')
      }

      if (this.kind === 'employee') {
        return this.$t('Common.employees')
      }

      if (this.kind === 'project') {
        return this.$t('Common.projects')
      }

      if (this.kind === 'incentives') {
        return this.$t('Common.incentives')
      }

      if (this.kind === 'approvePayment') {
        return this.$t('Common.charges')
      }

      return ''
    },

    title () {
      return this.maxLinesTitle
        ? this.replaceText(this.$t(`${this.namespace}.maxLinesTitle`))
        : this.$t(`${this.namespace}.title`)
    },

    buttonLabel () {
      return this.replaceText(this.$t(`${this.namespace}.buttonLabel`))
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.uploadBox',
      currentStatus: null,
      shouldSendWelcomeEmail: true
    }
  },
  methods: {
    replaceText (str) {
      return str
        .replace(/\[MAX_LINES\]/g, formatNumber(this.maxLines))
        .replace(/\[TYPE\]/g, this.type.toLowerCase())
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  background-color: var(--gray-1);
  border: 1px dashed var(--gray-4);
  display: block;
  padding: 26px;
  position: relative;
  text-align: center;

  .upload__text {
    margin-bottom: 16px;
  }
}

.form__container__header {
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.v-input {
  margin: 12px 0 0;
  padding: 0;

  @media (min-width: 768px) {
    justify-content: flex-end;
    margin-top: 0;
  }
}
</style>
